module.exports = ".card-img {\n  width: 250px !important;\n  height: 200px; }\n\n.card-title {\n  font-weight: bold; }\n\n.color {\n  background-color: #01579b; }\n\n.tabs, .tab a {\n  color: #01579b   !important; }\n\n.tabs .tab a:hover, .tabs .tab a.active {\n  color: white !important;\n  background-color: #01579b; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cursos/desenvolvimento/desenvolvimento.component.scss
// module id = ./src/app/cursos/desenvolvimento/desenvolvimento.component.scss
// module chunks = main